import AuthUITemplate from "./AuthUI";
import { useEffect } from "react";
import Button from "../../components/common/Button";
import { useParams, Navigate } from "react-router-dom";
import { usePasswordConfirm } from "react-redux-django-auth";
import useAuthRedirect from "../../hooks/useAuthRedirect";
import { useToast } from "../../hooks/otherHooks/useToast";
import Input from "../../components/common/Input";
import { Lock } from "lucide-react";

const NewPasswordConfirm = () => {
    const { uid, token } = useParams();

    // Initial Data
    const initialFormData = {
        uid: uid,
        token: token,
        new_password: "",
        re_new_password: "",
    };

    const { error, isStatus204, formData, loading, onChange, onSubmit } =
        usePasswordConfirm(initialFormData);

    // Toast
    const { showToast, redirectPage } = useAuthRedirect(isStatus204);

    const { addToast } = useToast();

    useEffect(() => {
        if (showToast) {
            addToast({
                message: "New Password Creation Success. Redirecting...",
                bg: "success",
            });
        }
    }, [showToast, addToast]);

    if (redirectPage) {
        return <Navigate to="/login" />;
    }
    return (
        <AuthUITemplate title="Enter New Password" errorMsg={error}>
            <form className="cht-space-y-4" onSubmit={(e) => onSubmit(e)}>
                <Input
                    label="New Password"
                    labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
                    type="password"
                    id="new_password"
                    name="new_password"
                    placeholder="••••••••"
                    leftIcon={<Lock size={18} />}
                    onChange={(e: any) => onChange(e)}
                    value={formData.new_password}
                    required
                />

                <Input
                    label="Confirm New Password"
                    labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
                    type="password"
                    id="re_new_password"
                    name="re_new_password"
                    placeholder="••••••••"
                    leftIcon={<Lock size={18} />}
                    onChange={(e: any) => onChange(e)}
                    value={formData.re_new_password}
                    required
                />

                <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    fullWidth
                    isLoading={loading}
                    disabled={loading}
                    className="cht-w-full cht-mt-4 cht-py-4 cht-uppercase cht-tracking-widest cht-text-xs cht-rounded-2xl"
                >
                    Change Password
                </Button>
            </form>
        </AuthUITemplate>
    );
};

export default NewPasswordConfirm;
